import { render } from "./ActiveType.vue?vue&type=template&id=05a9fce5&scoped=true"
import script from "./ActiveType.vue?vue&type=script&lang=js"
export * from "./ActiveType.vue?vue&type=script&lang=js"

import "./ActiveType.vue?vue&type=style&index=0&id=05a9fce5&lang=scss&scoped=true"

import exportComponent from "D:\\programs\\guocode-legacy\\guocodeadmin-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05a9fce5"]])

export default __exports__